import http from "@/settings/apiSettings";

class UserAdminService {
  getAll(): Promise<any> {
    return http.clientAuth.get("/AUTH_UserAdmin/GetAll");
  }

  setActive(id: string, active: boolean): Promise<any> {
    return http.clientAuth.patch(`/AUTH_UserAdmin/SetActive/${id}`, { Active: active });
  }

  getCompanies(username: string): Promise<any> {
    return http.clientAuth.get(`/AUTH_UserAdmin/Companies/${username}`);
  }

  impersonate(username: string, companyId: string): Promise<any> {
    return http.clientAuth.post("/Auth/impersonate", { Username: username, CompanyID: companyId });
  }

  resetPassword(id: string): Promise<any> {
    return http.clientAuth.post(`/AUTH_Users/${id}/reset-password`);
  }

  createUser(data: { Username: string; Email: string; Password?: string }): Promise<any> {
    return http.clientAuth.post("/AUTH_UserAdmin/CreateUser", data);
  }

  addToCompany(userCompanyId: string, companyId: string): Promise<any> {
    return http.clientAuth.post("/AUTH_UserAdmin/AddToCompany", {
      UserCompanyId: userCompanyId,
      CompanyId: companyId,
    });
  }

  removeFromCompany(userCompanyId: string, companyId: string): Promise<any> {
    return http.clientAuth.delete("/AUTH_UserAdmin/RemoveFromCompany", {
      data: { UserCompanyId: userCompanyId, CompanyId: companyId },
    });
  }

  importUsers(file: File): Promise<any> {
    const fd = new FormData();
    fd.append("file", file);
    return http.clientAuth.post("/AUTH_UserAdmin/ImportUsers", fd, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("ERA_Jwt"),
      },
    });
  }

  downloadImportTemplate(): Promise<any> {
    return http.clientAuth.get("/AUTH_UserAdmin/ImportTemplate", { responseType: "blob" });
  }
}

export default new UserAdminService();
